import React, { useEffect, useState } from 'react';
import { View, Modal } from 'react-native';
import { useNavigation } from "@react-navigation/native";

import HeaderDefault from '../../components/HeaderDefault';
import AuthCodeInput from '../../components/Form/AuthCodeInput';
import ModalPurchase from '../../components/ModalPurchase';

import AsyncStorage from '@react-native-async-storage/async-storage';

import api from '../../services/api';

import styles from './styles';
import ModalSell from '../../components/ModalSell';
import toast from '../../utils/toast';


/*
PROPS -> 
purchase boolean
qtd float
valueToken parseFloat
token activeId/tokenId
market boolean
*/

const ConfirmPasswordPurchaseOrSell = (props) => {
    const navigation = useNavigation();
    const [password, setPassword] = useState('');
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        resetPassword();
    }, [password])

    const getMarketplaceToken = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        var data = {
            qtd: props.route.params.qtd,
            id_coin: props.route.params.token,
            valueToken: props.route.params.valueToken,
            password: password,
            isBuy: props.route.params.purchase
        };

        api.post('marketplace-moviments', data, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                //      console.log(res.data)
                setModalVisible(!modalVisible);
            })
            .catch((error) => {
                if (error.response?.data?.message) {
                    toast(error.response?.data?.message, "#DA1414");
                }
            })
    }

    const getExchangeToken = async () => {
        const token = await AsyncStorage.getItem('JWT_TOKEN');

        var data = {
            quantity: props.route.params.qtd,
            id_token: props.route.params.token,
            value: props.route.params.valueToken, //props.route.params.market === false ? props.route.params.valueToken : null,
            is_purchase: props.route.params.purchase,
            password: password
        }

        api.post('exchange-order', data, { headers: { 'Authorization': `Basic ${token}` } })
            .then((res) => {
                //      console.log(res.data)
                setModalVisible(!modalVisible);
            })
            .catch((error) => {
                if (error.response?.data?.message) {
                    toast(error.response?.data?.message, "#DA1414");
                }
                console.log(error);
            })
    }


    const resetPassword = () => {
        // console.log('password length ' + password.length);
        // console.log('route params');
        // console.log(props.route.params);

        if (password.length === 6 && !props.route.params?.market) {
            getMarketplaceToken();
        } else if (password.length === 6) {
            getExchangeToken();
        }
    }

    return (
        <>
            <HeaderDefault title="Confirmar senha" />

            <View style={styles.container}>
                <AuthCodeInput
                    cellCount={6}
                    isPassword={true}
                    value={password}
                    onValueChange={(value) => setPassword(value)}
                    label="Digite a sua senha"
                />
            </View>
            <Modal
                animationType="fade"
                transparent={false}
                visible={modalVisible}
                statusBarTranslucent={true}
                onRequestClose={() => navigation.navigate('Tabs')}
            >
                {
                    props.route.params.purchase ?
                        <ModalPurchase
                            handleCloseModal={() => {
                                setModalVisible(false);
                                navigation.navigate('Tabs');
                            }}
                            handleCloseWithTransaction={() => {
                                setModalVisible(false);
                                navigation.navigate({ name: 'Tabs', params: { openTransaction: true } });
                            }}
                            showTransactionSlip={props.route.params.purchase && !props.route.params?.market}
                        />
                        :
                        <ModalSell
                            handleCloseModal={() => {
                                setModalVisible(false);
                                navigation.navigate('Tabs');
                            }} />
                }

            </Modal>
        </>
    );
}

export default ConfirmPasswordPurchaseOrSell;